/*
 *
 * EasySplitSettlements actions
 *
 */

import {
  CREATE_VENDOR_BALANCE_TRANSFER,
  DEFAULT_ACTION,
  DISABLE_LOADER,
  ENABLE_LOADER,
  GENERATE_SETTLEMENT_REPORT,
  GET_ON_DEMAND_TABLE_DATA,
  GET_SCHEDULED_TABLE_DATA,
  GET_SETTLEMENT_TIMELINE,
  GET_TRANSFER_BALANCE,
  GET_TRANSFER_CHARGES,
  RESET_FILTERS,
  RESET_PAGE,
  SAVE_TRANSFER_BALANCE_SUCCESS,
  UPDATE_FILTERS,
} from './constants';

export function defaultAction() {
  return {
    type: DEFAULT_ACTION,
  };
}

export function getTransferBalanceAction(data) {
  return {
    type: GET_TRANSFER_BALANCE,
    data,
  };
}

export function getTransferChargesAction(data) {
  return {
    type: GET_TRANSFER_CHARGES,
    data,
  };
}

export function getOnDemandTableDataAction(data) {
  return {
    type: GET_ON_DEMAND_TABLE_DATA,
    data,
  };
}

export function getScheduledTableDataAction(data) {
  return {
    type: GET_SCHEDULED_TABLE_DATA,
    data,
  };
}

export function updateFiltersAction(data) {
  return {
    type: UPDATE_FILTERS,
    data,
  };
}

export function resetFiltersAction() {
  return {
    type: RESET_FILTERS,
  };
}

export function resetPageAction() {
  return {
    type: RESET_PAGE,
  };
}

export function generateSettlementReportAction(data) {
  return {
    type: GENERATE_SETTLEMENT_REPORT,
    data,
  };
}

export function enableLoaderAction() {
  return {
    type: ENABLE_LOADER,
  };
}

export function disableLoaderAction() {
  return {
    type: DISABLE_LOADER,
  };
}

export function createVendorBalanceTransferAction(data) {
  return {
    type: CREATE_VENDOR_BALANCE_TRANSFER,
    data,
  };
}

export function saveTransferBalanceSuccessAction(data) {
  return {
    type: SAVE_TRANSFER_BALANCE_SUCCESS,
    data,
  };
}

export function getSettlementTimelineAction(data) {
  return {
    type: GET_SETTLEMENT_TIMELINE,
    data,
  };
}
